import { jsx as r } from "react/jsx-runtime";
import { lazy as l, useEffect as o } from "react";
import { ErrorBoundary as u } from "react-error-boundary";
import { I18nextProvider as c } from "react-i18next";
import { LoadingEnum as d, I18nService as g } from "@perxis-auto/shared";
import { useStages as E } from "@perxis-auto/trade-in-sdk";
import { Provider as I } from "@perxis-auto/ui-kit/lib/components/Provider";
import A from "../shared/assets/locales/en/translation.json.js";
import v from "../shared/assets/locales/ru/translation.json.js";
import T from "../shared/assets/locales/uz/translation.json.js";
import { EVENT_WIDGET_INITIALIZED as h } from "../shared/config/events.js";
import { useAppContext as L, LanguageEnum as S } from "../shared/lib/app/context/appContext.js";
import { sendEvent as x } from "../shared/lib/event/sendEvent.js";
import { AppLayout as y } from "./layouts/AppLayout/AppLayout.js";
import { SuspenseLayout as P } from "./layouts/SuspenseLayout/SuspenseLayout.js";
import { AppProvider as z } from "./providers/AppProvider/AppProvider.js";
import { AppRouter as D } from "./router/AppRouter/AppRouter.js";
import "../shared/assets/styles/main.scss.js";
/* empty css         */
const N = l(() => import("../pages/ErrorStage/index.js")), _ = ({ onSuccess: t, onFailure: n, onReset: i }) => {
  const { setAppHandlers: m, language: p = S.Ru, iconSet: a } = L(), {
    actions: { getStages: s },
    loading: e
  } = E();
  o(() => {
    e === d.Idle && s();
  }, [e]), o(() => {
    m({
      onSuccess: t,
      onFailure: n,
      onReset: i
    });
  }, [n, i, t, m]), o(() => {
    x(h);
  }, []);
  const f = g.getInstance({
    language: p,
    resources: {
      ru: {
        translation: v
      },
      en: {
        translation: A
      },
      uz: {
        translation: T
      }
    }
  }).i18n;
  return /* @__PURE__ */ r(I, { iconSet: a, children: /* @__PURE__ */ r(c, { i18n: f, children: /* @__PURE__ */ r(u, { fallback: /* @__PURE__ */ r(N, {}), children: /* @__PURE__ */ r(P, { children: /* @__PURE__ */ r(y, { children: /* @__PURE__ */ r(D, {}) }) }) }) }) });
};
_.Provider = z;
export {
  _ as App
};
